import { UnderlyingTagBase } from 'components/underlying-tag';
import { FC } from 'react';
import styled from 'styled-components';

export interface BlotterPanelUnderlyingsFieldProps {
  values: string[];
}

const StyledUnderlyingDiv = styled.div`
  margin: 1px;
  & > span {
    margin-right: 3px;

    &:last-child {
      margin-right: 0;
    }
  }
`;

export const BlotterPanelUnderlyingsField: FC<BlotterPanelUnderlyingsFieldProps> = ({ values }) => {
  if (!values.length) {
    return;
  }

  return (
    <StyledUnderlyingDiv>
      {values.map((underlying, i) => (
        <UnderlyingTagBase key={i} dataE2e="underlyings-badge" label={underlying} isReadOnly />
      ))}
    </StyledUnderlyingDiv>
  );
};

BlotterPanelUnderlyingsField.displayName = 'BlotterPanelUnderlyingsField';
